<template>
  <interview-layout :touch-and-validate="touchAndValidate">
    <!-- inner wrapper used for centering -->
    <div style="max-width: 540px;">
      <!-- title above form card -->
      <h1 class="px-4 pb-3 fade-in-up-enter-active animation-slowest delay-200 max-100">Twk</h1>

      <!-- form 1 card -->
      <base-card class="w-100" color="alternate" :outer-padding="true" :stretch-inner="true" inner-class="vw-100">
        <base-form @submit="onSubmit">

          <!-- info block on isolatieplan -->
          <base-card class="mt-3 mb-4" color="light" :stretch-inner="true">
            <h5 class="mb-4">Subsidie</h5>
            <info-item icon="bi-info-circle-fill text-info small" style="font-size: 1em;" class="mb-1">
              {{ intakeMeasuresText }}
            </info-item>
          </base-card>

          <!-- heeft u na 25 april 2023 isolatiemaatregelen laten uitvoeren of zelf uitgevoerd? (yesNo) -->
          <base-input
            v-if="lead.hasExecutedMeasures"
            type="radiobuttons" :options="yesNo"
            name="HasMeasuresForRetroactive"
            v-model:value="lead.twk.IntakeMeasuresExecuted">
            Heeft u na 25 april 2023 isolatiemaatregelen laten uitvoeren of zelf uitgevoerd?
          </base-input>
          <!-- <issue-feedback :issue="v$.isolatieplan.HasMeasuresForRetroactive" /> -->

          <!-- als ja: Heeft u deze gedeclareerd bij een andere subsidie? U mag niet meer dan 100% subsidie aanvragen voor een isolatiemaatregel -->
          <base-input
            v-if="lead.twk.IntakeMeasuresExecuted === true"
            type="radiobuttons" :options="yesNo"
            name="HasMeasuresForRetroactive"
            v-model:value="lead.isolatieplan.DeclaredAtOtherSubsidy" :validator="v$.isolatieplan.DeclaredAtOtherSubsidy">
            Heeft u deze al volledig gedeclareerd bij een andere subsidie? U mag niet meer dan 100% subsidie aanvragen voor een isolatiemaatregel
          </base-input>
          
          <!-- als ja: Welk bedrag heeft u na 25 april 2023 besteed aan isolatiemaatregelen? -->
          <!-- <base-input
            v-if="lead.isolatieplan.DeclaredAtOtherSubsidy === false && lead.twk.IntakeMeasuresExecuted"
            type="number"
            name="RetroactiveMeasuresTotalAmount" field-width="max-content" input-width="140px"
            v-model:value="lead.isolatieplan.RetroactiveMeasuresTotalAmount" :validator="v$.isolatieplan.RetroactiveMeasuresTotalAmount">
              <template #default>
                Welk bedrag heeft u na 25 april 2023 besteed aan isolatiemaatregelen?
              </template>
              <template #before>
                <span class="unit px-2 fs-0-8em fw-600 text-secondary">&euro;</span>
              </template>
          </base-input> -->

          <!-- als ja, welke maatregelen heeft u uitgevoerd? -->
          <!-- label -->
          <p v-if="lead.isolatieplan.DeclaredAtOtherSubsidy === false && lead.twk.IntakeMeasuresExecuted" class="mt-4 mb-2 fw-500 small">
            Welke maatregelen heeft u uitgevoerd na 25 april 2023 en wilt u subsidie voor aanvragen?
          </p>
          <button-grid-input
            v-if="lead.isolatieplan.DeclaredAtOtherSubsidy === false && lead.twk.IntakeMeasuresExecuted"
            name="RetroactiveMeasures"
            :max-cols="maxCols"
            :btn-direction="btnDirection"
            type="checkbox"
            btn-class="min-40"
            :pairs-mode="true"
            :distribute-equally="true"
            :options="executedMeasuresOptions"
            variant="minimal-filled-info"
            inactive-variant="minimal-dark"
            :validator="v$.isolatieplan.RetroactiveMeasures"
            v-model:value="lead.isolatieplan.RetroactiveMeasures">
            Welke maatregelen heeft u uitgevoerd?
          </button-grid-input>

          <!-- buttons -->
          <button-row class="mt-5">
            <base-button class="ms-auto" icon="bi-arrow-right" type="submit" :disabled="v$.isolatieplan.$invalid">Volgende</base-button>
          </button-row>
        </base-form>
        <!-- form card end -->
      </base-card>

      <button-row class="mt-2">
        <base-button variant="minimal-secondary" icon="bi-arrow-left" icon-position="start" @click="onPrev">Terug</base-button>
      </button-row>
      <!-- inner wrapper end -->
    </div>
  </interview-layout>
</template>

<script>
  import InterviewLayout from "@/views/layouts/InterviewLayout.vue"
  import BaseCard from '@/components/BaseCard.vue'
  import BaseForm from "@/components/BaseForm.vue"
  import BaseInput from "@/components/BaseInput.vue"
  import BaseButton from "@/components/BaseButton.vue"
  import ButtonRow from "@/components/ButtonRow.vue"
  import InfoItem from '@/components/InfoItem.vue';
  import ButtonGridInput from "@/components/ButtonGridInput.vue";

  import { useAllStores } from "@/helpers/UseAllStores"
  import { CommonComposable } from "@/helpers/CommonComposable"
  import { FlowService } from "@/services/FlowService"
  import { getInterestDefinitions } from "@/rules/InterestDefinitions"

  export default {
    components: {
      InterviewLayout,
      BaseCard,
      BaseForm,
      BaseInput,
      BaseButton,
      ButtonRow,
      InfoItem,
      ButtonGridInput
    },
    setup(props, context) {
      return { ...CommonComposable(props, context), ...useAllStores() };
    },
    data() {
      return {
        intakeMeasuresText: '',
        btnDirection: 'row',
        maxCols: 1,
        constructionYearDisabled: true,
        yesNo: [
          {
            label: 'Ja',
            value: true
          },
          {
            label: 'Nee',
            value: false
          },
        ],
        yesNoDontKnow: [
          {
            label: 'Ja',
            value: 'Ja'
          },
          {
            label: 'Nee',
            value: 'Nee'
          },
          {
            label: 'Niet mogelijk',
            value: 'Niet mogelijk'
          },
          {
            label: 'Weet ik niet',
            value: 'Weet ik niet'
          }
        ]
      };
    },
  mounted() {
    if (this.lead.twk.IntakeMeasuresExecuted === true) {
      this.intakeMeasuresText = 'Heeft aangegeven dat isolatiemaatregelen zijn uitgevoerd na 25 april 2023. Mogelijk komt bewoner in aanmerking voor subsidie.';
    } else if (this.lead.twk.IntakeMeasuresExecuted === false) {
      this.intakeMeasuresText = 'Heeft aangegeven dat er geen isolatiemaatregelen heeft uitgevoerd na 25 april 2023.';
    }
  },
  computed: {
      executedMeasuresOptions() {
        const executed = Array.isArray(this.lead.executedMeasures?.ExecutedMeasures)
          ? this.lead.executedMeasures.ExecutedMeasures
          : [];
        return this.interestOptions.filter(opt => executed.includes(opt.value));
      },
      isolatiePlanAlwaysRequired() {
        return this.lead.property.IsMonument == true || (this.lead.Isolatieplan_required_bouwjaar);
      },
      reasonIsolatieplanAlwaysRequired() {
        // if before 1965
        if (this.lead.property.IsMonument) {
          return ', omdat uw woning een monument is';
        } else if (this.lead.property.ConstructionYear < 1965) {
          return ', omdat uw woning is gebouwd vóór 1965';
        } else if (this.lead.property.ConstructionYear > 1991) {
          return ', omdat uw woning is gebouwd na 1991';
        }
        return null;
      },
      reasonIsolatieplanRequiredOver10k() {
        return ', omdat uw woning is gebouwd tussen 1965 en 1991';
      },
      interestOptions: function() {
        return getInterestDefinitions(this.lead.meta.AllInterestsEnabled, this.lead.meta.InterestWhiteList);
      }
    },
    methods: {
      touchAndValidate() {
        this.v$.isolatieplan.$touch();
        return !this.v$.isolatieplan.$invalid;
      },
      onSubmit() {
        if (this.touchAndValidate()) {
          FlowService.pushNext(this);
        }
      },
      onPrev() {
        FlowService.pushPrev(this);
      },
      breakPoints() {
        if (window.innerWidth > 500) {
          this.btnDirection = 'column';
          this.maxCols = 99;
        } else {
          this.btnDirection = 'row';
          this.maxCols = 1;
        }
      }
    }
  }
</script>

<style lang="scss">
</style>